import React from 'react';
import './Legal.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-card card">
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: April 6, 2026</p>

          <section>
            <h2>Acceptance</h2>
            <p>
              By using Petlings (the mod, website, or iOS app), you agree to these terms.
              If you don't agree, please don't use the service.
            </p>
          </section>

          <section>
            <h2>The Service</h2>
            <p>
              Petlings is a virtual pet companion platform for Minecraft. It includes a client-side Fabric mod,
              a web dashboard at petlings.gg, and an iOS app. The service allows you to adopt, customize, and
              care for AI-powered pet companions.
            </p>
          </section>

          <section>
            <h2>Accounts</h2>
            <ul>
              <li>You must be 13 or older to create an account</li>
              <li>You are responsible for keeping your password secure</li>
              <li>One account per person. Don't share accounts</li>
              <li>We may suspend accounts that violate these terms</li>
            </ul>
          </section>

          <section>
            <h2>Virtual Currency (Treats)</h2>
            <ul>
              <li>Treats are a virtual currency with no real-world value</li>
              <li>Treats cannot be exchanged for real money or transferred between accounts</li>
              <li>Purchased treats are non-refundable (Tebex handles payment disputes)</li>
              <li>We may adjust treat prices, rewards, or balances to maintain the economy</li>
              <li>All treats are earnable through gameplay without spending real money</li>
            </ul>
          </section>

          <section>
            <h2>AI Chat</h2>
            <ul>
              <li>Pet chat is powered by AI and may occasionally produce unexpected responses</li>
              <li>Don't use the chat system to generate harmful, illegal, or abusive content</li>
              <li>Chat messages are stored for history and may be used to improve the service</li>
              <li>We reserve the right to limit or disable chat access for accounts that violate these terms</li>
            </ul>
          </section>

          <section>
            <h2>Acceptable Use</h2>
            <p>Don't:</p>
            <ul>
              <li>Exploit bugs, glitches, or vulnerabilities in the service</li>
              <li>Attempt to reverse-engineer, decompile, or modify the mod beyond what is allowed by the license</li>
              <li>Use automated tools to create accounts, earn treats, or abuse the API</li>
              <li>Impersonate other users or Petlings staff</li>
              <li>Use the service for any illegal purpose</li>
            </ul>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <p>
              Petlings, including all code, art, and design, is the property of its creators.
              The mod source code is available for reference only - redistribution, modification,
              or commercial use is prohibited without written permission.
            </p>
          </section>

          <section>
            <h2>Disclaimer</h2>
            <p>
              Petlings is provided "as is" without warranty. We don't guarantee uptime, data preservation,
              or compatibility with all Minecraft versions or mods. Use at your own risk.
            </p>
            <p>
              <strong>Not an official Minecraft product. Not approved by or associated with Mojang or Microsoft.</strong>
            </p>
          </section>

          <section>
            <h2>Changes</h2>
            <p>
              We may update these terms from time to time. Continued use of the service after changes
              constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              Questions? Email us at <a href="mailto:hello@petlings.gg">hello@petlings.gg</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
